'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Observer-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError$002dHandling$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Observer-Error-Handling-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$8(onNextParam$2, handleObserverErrors$3, onErrorParam$2, outer) {
  this.DF = null;
  this.DD = false;
  this.yk = null;
  this.DE = null;
  this.DF = onNextParam$2;
  this.DD = handleObserverErrors$3;
  this.yk = onErrorParam$2;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.DE = (void 0);
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$8 as $c_Lcom_raquo_airstream_core_Observer$$anon$8 };
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$8;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$8() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$8 as $h_Lcom_raquo_airstream_core_Observer$$anon$8 };
$h_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = $p;
$p.dP = (function() {
  return this.DE;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.lh = (function() {
  return this;
});
$p.cW = (function(nextValue) {
  try {
    this.DF.j(nextValue);
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    if (this.DD) {
      this.l6(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    }
  }
});
$p.l6 = (function(error) {
  try {
    if (this.yk.de(error)) {
      this.yk.j(error);
    } else {
      $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(error);
    }
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError$002dHandling$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, error));
  }
});
$p.fY = (function(nextValue) {
  nextValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((error) => {
    this.l6(error);
  })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((nextValue$2) => {
    this.cW(nextValue$2);
  })));
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$8, "com.raquo.airstream.core.Observer$$anon$8", ({
  gL: 1,
  aP: 1,
  M: 1,
  bH: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$8 as $d_Lcom_raquo_airstream_core_Observer$$anon$8 };
